var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RenderIf } from 'syf-component-library/ui/atoms';
import { Stack } from 'syf-component-library/ui/spacing';
import { StyledFlex } from '../../../styles/common';
import { StyledText, StyledTitle } from '../../../styles/text';
import EmptyWheelChart from './empty-wheel-chart';
import { StyledSpendingTrendsChart } from './subcomponents';
import WheelChart from './wheel-chart';
var SpendingTrendsChart = function (_a) {
    var data = _a.data, totalAmount = _a.totalAmount, setSelectedCategory = _a.setSelectedCategory;
    var t = useTranslation().t;
    var sortedData = __spreadArray([], data, true).sort(function (a, b) {
        return Number(b.amount) - Number(a.amount);
    });
    var formattedData = sortedData.map(function (item) { return ({
        amount: item.amount,
        color: item.borderColor,
        name: item.category,
        value: parseFloat(item.percentage)
    }); });
    /** default selecting the category with the highest spending percentage */
    useEffect(function () {
        var _a;
        setSelectedCategory((_a = formattedData[0]) === null || _a === void 0 ? void 0 : _a.name);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var isEmpty = !formattedData.length;
    return (_jsxs(StyledSpendingTrendsChart, { direction: "column", alignItems: "center", children: [_jsxs(StyledFlex, { direction: "column", alignItems: "center", children: [_jsx(StyledTitle, { as: "h4", weight: "light", size: "large", color: "black", children: t('spendingTrends.chartHeading') }), _jsx(Stack, { size: "small" }), _jsx(StyledText, { align: "center", color: "black", children: t('spendingTrends.chartSubHeading') })] }), _jsx(Stack, { size: "large" }), _jsx(RenderIf, { condition: !isEmpty, children: _jsx(WheelChart, { data: formattedData, totalAmount: totalAmount, setSelectedCategory: setSelectedCategory }) }), _jsx(RenderIf, { condition: isEmpty, children: _jsx(EmptyWheelChart, {}) })] }));
};
export default SpendingTrendsChart;
//# sourceMappingURL=index.js.map